module.exports = __webpack_public_path__ + "static/media/14.b1d9c6d2.png";